export const COLORS = {
  primary: "#fff",
  secondry: "#19be6f",
  text: "#062a3f",
  hover: "#117b48",
};
